import { ModalContentFC, GlobalModalOpenProps } from 'app-view/components/Modal'

export const get_error_modal_props = (content: ModalContentFC): GlobalModalOpenProps => ({
  content,
  showClose: true,
  autoHide: false,
  title: 'Error',
  iconType: 'ERROR',
})
